var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('common-calendar',{ref:"calendar",attrs:{"calendarOption":_vm.calendarOptions,"classes":'fullcalendar-header-style-md',"onEventClick":_vm.handleEventClick,"filterObj":_vm.filters,"api":_vm.apiCall,"filters":{ setCustomButtons: true, isSlot: true }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }